import React, {FunctionComponent} from "react";
import NextError from 'next/error'

interface ErrCodeException extends Error {
    code?: string;
}

const Throw404: FunctionComponent<{}> = () => {
    if (process.browser) {
        return <NextError statusCode={404} />
    }

    const e = new Error() as ErrCodeException
    e.code = 'ENOENT'
    throw e;
}

export default Throw404;
